export const sanitiseFilterString = (filterString) => {
  return filterString.replace(/[\[\]']+/g,'-') //replace square brackets with -
}